<template>
	<div>
		<CModal title="Clôturer le ticket" size="lg" :show.sync="showModal">
			<form ref="closeTicketForm" :action="ticket['@id']" method="post" axiosMethod="patch">
				<CSelect
					label="Raison de la clôture du ticket"
					:options="closedReasonOptions"
					v-on:update:selected="data => (closedReason = data)"
					name="closedReason"
					placeholder="Choisissez une raison..." />
				<GTreeView
					label="Responsable"
					input-name="responsibleActor"
					:multiple="false"
					:local-data="responsibleActorOptions"
					placeholder="Choisissez le responsable" />
				<CTextarea
					name="closedReasonDetails"
					v-model="closedReasonDetails"
					label="Précisez la raison (optionnel)" />
				<CInput type="hidden" name="status" value="support_ticket.status.closed" />
			</form>
			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.closeTicketForm)">Clôturer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GTreeView from '../../../../../components/ghostlexly-components/GTreeView';
	export default {
		components: { GTreeView },
		props: {
			ticket: Object,
		},
		data() {
			return {
				showModal: false,
				closedReasonDetails: null,
				closedReason: null,
				closedReasonOptions: [
					{
						value: 'support_ticket.closed_reason.resolved',
						label: 'Problème résolu',
					},
					{
						value: 'support_ticket.closed_reason.reimbursed',
						label: 'Coli(s) remboursé(s)',
					},
					{
						value: 'support_ticket.closed_reason.reshipped',
						label: 'Coli(s) Réexpédié(s)',
					},
					{
						value: 'support_ticket.closed_reason.other',
						label: 'Autre (précisez)',
					},
				],
				responsibleActorOptions: [
					{
						'@id': 'support_ticket.responsible.colipays',
						name: 'Colipays',
					},
					{
						'@id': 'support_ticket.responsible.chronopost',
						name: 'Chronopost',
					},
					{
						'@id': 'support_ticket.responsible.customer',
						name: 'Client',
					},
				],
			};
		},
		methods: {
			onSubmit(form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Ticket clôturé avec succès !');
						this.showModal = false;
						this.$emit('update:ticket', res.data);
					}
				});
			},
		},
	};
</script>
